<template>
    <el-row :gutter="0" class="grid-row">
        <el-col :span="gridWidth" class="simulation-numbers" v-if="data.max !== null">
            <div class="left">{{ data.min }}</div>
            <div class="center">à</div>
            <div
                v-if="write"
                class="input-container"
            >
                <el-input
                    :value="data.max"
                    class="max-input"
                    type="number"
                    @input="changeMaxValue"
                ></el-input>
            </div>
            <div v-else class="right">{{ data.max }}</div>
        </el-col>
        <el-col :span="gridWidth" class="simulation-numbers-infinite" v-else>
            <div>À partir de {{ data.min }} simulations</div>
        </el-col>
        <el-col :span="6" class="simulation-price">
            <div
                v-if="write"
                class="input-container"
            >
                <el-input
                    :value="data.price"
                    class="price-input"
                    type="number"
                    @input="changePriceValue"
                ></el-input>
            </div>
            <div v-else>{{data.price}}€</div>
        </el-col>
        <el-col v-if="write" :span="4" class="operations">
            <el-tooltip
                class="item"
                effect="dark"
                content="Ajouter une tranche"
                placement="top"
            >
                <i v-if="plusIcon" class="ti-plus" @click="addLine"></i>
            </el-tooltip>
            <el-tooltip
                class="item"
                effect="dark"
                content="Supprimer la tranche"
                placement="top"
            >
                <i v-if="deleteIcon" class="ti-trash" @click="removeLine"></i>
            </el-tooltip>
        </el-col>
    </el-row>
</template>

<script>

export default {
    props: {
        data: {
            type: Object,
            required: true
        },
        index: {
            type: Number,
            default: -1
        },
        write: {
            type: Boolean,
            default: false
        },
        plusIcon: {
            type: Boolean,
            default: false
        },
        deleteIcon: {
            type: Boolean,
            default: false
        }
    },
    components: {
    },
    data () {
        return {
        };
    },
    computed: {
        gridWidth() {
            if (this.write) {
                return 14;
            }
            return 18;
        }
    },
    methods: {
        addLine() {
            this.$emit('addLine', this.index);
        },
        removeLine() {
            this.$emit('removeLine', this.index);
        },
        changeMaxValue(newMaxValue) {
            this.$emit('changeMaxValue', {newValue: newMaxValue, index: this.index});
        },
        changePriceValue(newPriceValue) {
            this.$emit('changePriceValue', {newValue: newPriceValue, index: this.index});
        }
    }
};
</script>

<style lang="scss">
.grid-row {
    height: 40px;
    .simulation-numbers {
        display: flex;
        height: 100%;
        justify-content: space-around;
        align-items: center;
        .left, .right {
            width: 40%;
            text-align: center;
        }
        .center {
            text-align: center;
            width: 20%;
        }
    }
    .input-container {
        height: 100%;
        padding: 5px 10px;
        .price-input, .max-input {
            height: 100%;
            input {
                text-align: center;
                height: 100%;
            }
        }
    }
    .simulation-numbers-infinite {
        display: flex;
        height: 100%;
        justify-content: flex-start;
        align-items: center;
        padding-left: 20px;
    }
    .simulation-price {
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: rgba(74, 74, 74, 0.0979);
    }
    .operations {
        background-color: #FFF;
        display: flex;
        align-items: center;
        height: 100%;
        justify-content: space-between;
        padding: 0 8px;
        color: #409EFF;
        i {
            cursor: pointer;
        }
    }
}

</style>



// WEBPACK FOOTER //
// src/components/Pricing/gridRow.vue